import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import downloadAttachment from '../functions/downloadAttachment';

const AttachmentLink = ({ attachment, id }) => {
  const [downloadInProcess, setDownloadInProcess] = useState(false);
  const { attachmentName, attachmentId } = attachment;
  return (
    <div>
      {downloadInProcess ? (
        <div>
          <CircularProgress size={22} />
        </div>
      ) : (
        <Button
          onClick={() => {
            setDownloadInProcess(true);
            downloadAttachment(
              id,
              attachmentId,
              attachmentName,
              setDownloadInProcess
            );
          }}
          color="primary"
        >
          {attachmentName}
        </Button>
      )}
    </div>
  );
};

AttachmentLink.propTypes = {
  id: PropTypes.string.isRequired,
  attachment: PropTypes.object.isRequired,
};

export default AttachmentLink;
